export const setupSelectRowListener = (targetElement: Element, onNextStep: () => void): (() => void) => {
  let hasTriggered = false;

  const clickHandler = () => {
    if (hasTriggered) return;
    setTimeout(() => {
      if (hasTriggered) return;
      const selectedRow = targetElement.querySelector('.row-selected');
      if (selectedRow) {
        hasTriggered = true;
        onNextStep();
      }
    }, 50);
  };

  targetElement.addEventListener('click', clickHandler, true);

  return () => {
    targetElement.removeEventListener('click', clickHandler, true);
  };
};
